export const openLinkInNewTab = (link: string) => {
  const w = window.open(link, "_blank");
  if (w) {
    w.focus();
  }
};
